import React, { useMemo } from "react";
import ReactQuill from "react-quill";
import { message } from "antd";
import { uploadOne } from "../../../utils/utils";

const formats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "list",
  "bullet",
  "link",
  "image",
  "blockquote",
  "code-block",
  "align",
  "color",
  "background",
];

export const RichText = ({
  value,
  onChange,
  placeholder = "Write something…",
}) => {
  const handleChange = (html) => {
    if (/src=["']data:image\//i.test(html)) {
      message.error("Images must be uploaded instead of pasted as base64.");
      return;
    }

    onChange(html);
  };

  const modules = useMemo(
    () => ({
      toolbar: {
        container: [
          [{ header: [1, 2, 3, false] }],
          ["bold", "italic", "underline", "strike"],
          [{ list: "ordered" }, { list: "bullet" }],
          ["link", "image", "blockquote", "code-block"],
          [{ align: [] }, { color: [] }, { background: [] }],
          ["clean"],
        ],
        handlers: {
          image: function imageHandler() {
            const input = document.createElement("input");
            input.setAttribute("type", "file");
            input.setAttribute("accept", "image/*");
            input.click();

            input.onchange = async () => {
              const file = input.files?.[0];
              if (!file) return;

              try {
                const url = await uploadOne(file);
                const range = this.quill.getSelection(true);
                this.quill.insertEmbed(range.index, "image", url);
                this.quill.setSelection(range.index + 1);
              } catch (error) {
                message.error(
                  error?.response?.data?.message || "Image upload failed",
                );
              }
            };
          },
        },
      },
      clipboard: { matchVisual: false },
    }),
    [],
  );

  return (
    <div style={{ marginBlock: "1rem", width: "100%" }}>
      <ReactQuill
        theme="snow"
        value={value}
        onChange={handleChange}
        modules={modules}
        formats={formats}
        placeholder={placeholder}
      />
    </div>
  );
};
export default RichText;
